import { trpc } from './trpc'
import { inferRouterOutputs, inferRouterInputs } from '@trpc/server'
import { AppRouter } from '@tagadapay/trpc-types'
import { useToast } from '@/components/ui/use-toast'

type OutputRouter = inferRouterOutputs<AppRouter>
type InputRouter = inferRouterInputs<AppRouter>

// Output types
export type UploadImageOutput = OutputRouter['images']['upload']

// Input types
export type UploadImageInput = InputRouter['images']['upload']

// Hook for uploading images
export const useUploadImage = () => {
	const utils = trpc.useUtils()
	const { toast } = useToast()
	return trpc.images.upload.useMutation({
		onSuccess: () => {
			utils.images.invalidate()
			toast({
				title: 'Success',
				description: 'Image uploaded successfully',
			})
		},
	})
}

